import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

// images
import UpActiveImg from '../../assets/image/scroll/ic-up-a.svg'
import UpInactiveImg from '../../assets/image/scroll/ic-up-i.svg'
import DownActiveImg from '../../assets/image/scroll/ic-down-a.svg'
import DownInactiveImg from '../../assets/image/scroll/ic-down-i.svg'

// constants
const HIDE_URL = {
  SERVICE: '/serviceterms',
  PRIVACY: '/privacyterms',
  ERROR: '/error',
}

function ScrollButton() {
  const location = useLocation()
  const [activeIndex, setActiveIndex] = useState(null)

  const getScrollHeight = () => {
    const body = document.body
    const html = document.documentElement
    const height = Math.max(body.scrollHeight, html.scrollHeight)

    return height
  }

  const handleScroll = (flag) => {
    // const scrollHeight = getScrollHeight()
    const scrollSize = 300

    switch (flag) {
      case 0:
        window.scrollBy(0, `-${scrollSize}`)

        break

      case 1:
        window.scrollBy(0, scrollSize)

        break

      default:
        break
    }
  }

  // 숨김(푸터 서비스 이용약관, 푸터 개인정보처리방침, 에러)
  if (
    location.pathname === HIDE_URL.SERVICE ||
    location.pathname === HIDE_URL.PRIVACY ||
    location.pathname === HIDE_URL.ERROR
  ) {
    return null
  }

  // 나머지 화면
  return (
    <Container>
      <Wrapper>
        <Up
          onMouseOut={() => setActiveIndex(null)}
          onMouseOver={() => setActiveIndex(0)}
          onClick={() => handleScroll(0)}
          id="upBttn"
        >
          <img src={activeIndex === 0 ? UpActiveImg : UpInactiveImg} />
        </Up>
        <Down
          onMouseOut={() => setActiveIndex(null)}
          onMouseOver={() => setActiveIndex(1)}
          onClick={() => handleScroll(1)}
          id="downBttn"
        >
          <img src={activeIndex === 1 ? DownActiveImg : DownInactiveImg} />
        </Down>
      </Wrapper>
    </Container>
  )
}

export default ScrollButton

const Container = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999;

  right: 6px;
  top: 449px;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Up = styled.div`
  width: 40px;
  height: 60px;
  border: 1px solid ${colors.G3};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);

  &:hover {
    background-color: #17a61c;
  }

  img {
    width: 18px;
    height: 18px;
  }
`

const Down = styled.div`
  margin-top: 6px;
  width: 40px;
  height: 60px;
  border: 1px solid ${colors.G3};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);

  &:hover {
    background-color: #17a61c;
  }

  img {
    width: 18px;
    height: 18px;
  }
`
